const actions = {
  setIsMobile: async function({commit}, isMobile) {
    commit('setIsMobile', isMobile);
  },

};

export default actions;



// WEBPACK FOOTER //
// ./src/common/mobile/vuex/actions.js